import type { ActivityLogRow } from '@/data/types';

export interface SocialShopSummaryRow {
  isFromSocialShop?: boolean;
  socialShopEntity?: string | null;
  isSocialShopOwnerShared?: boolean;
  socialShopEntityId?: string | null;
  socialShopName?: string | null;
  socialShopAvatar?: string | null;
  unitsSold?: number;
  totalRevenue?: number;
}

export function getSocialShopInsightsLabel(row: SocialShopSummaryRow): string {
  if (row.isSocialShopOwnerShared && row.socialShopName) {
    return row.socialShopName;
  }
  return "A member's shop";
}

export function getSocialShopInsightsProfilePath(row: SocialShopSummaryRow): string | null {
  if (!row.isSocialShopOwnerShared || !row.socialShopEntityId) {
    return null;
  }

  if (row.socialShopEntity === 'Organization') {
    return `/web/profile/organization/${row.socialShopEntityId}`;
  }

  if (row.socialShopEntity === 'User') {
    return `/web/profile/user/${row.socialShopEntityId}`;
  }

  return null;
}

export function getSocialShopSourceLabel(row: ActivityLogRow): string | null {
  if (!row.isFromSocialShop) {
    return null;
  }

  if (row.isSocialShopOwnerShared) {
    return row.socialShopName ? `via ${row.socialShopName}` : 'via a shop';
  }

  return "via a member's shop";
}

export function getSocialShopProfilePath(row: ActivityLogRow): string | null {
  if (!row.isFromSocialShop || !row.isSocialShopOwnerShared || !row.socialShopEntityId) {
    return null;
  }

  if (row.socialShopEntity === 'Organization') {
    return `/web/profile/organization/${row.socialShopEntityId}`;
  }

  if (row.socialShopEntity === 'User') {
    return `/web/profile/user/${row.socialShopEntityId}`;
  }

  return null;
}

export function formatSocialShopSourceForExport(row: ActivityLogRow): string {
  return getSocialShopSourceLabel(row) ?? '';
}
